export const Layers = (props) => (
  <svg width="35px" height="42px" viewBox="0 0 35 42" {...props}>
    <g
      id="Features"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="feature---Dunning" transform="translate(-1219.000000, -2741.000000)" strokeWidth="1.5">
        <g id="Group-7" transform="translate(217.000000, 2372.000000)">
          <g id="Group-58" transform="translate(743.000000, 94.000000)">
            <g id="Group-25">
              <g id="Group-26" transform="translate(260.000000, 276.000000)">
                <g id="2-right">
                  <path
                    d="M31.584755,31.1491833 L16.3397459,39.6188748 C14.8871143,40.4246824 13.1034483,39.3749546 13.1034483,37.7154265 L13.1034483,20.9197822 C13.1034483,20.1292196 13.5324864,19.399637 14.2228675,19.0163339 L29.4678766,10.5466425 C30.9205082,9.73865699 32.7041742,10.7883848 32.7041742,12.4500907 L32.7041742,29.245735 C32.7041742,30.0362976 32.2751361,30.7637024 31.584755,31.1491833 Z"
                    id="Path"
                    stroke="currentColor"
                  />
                  <path
                    d="M26.1705989,4.39201452 L7.67186933,14.8980036 C6.99019964,15.2834846 6.56987296,16.0065336 6.56987296,16.7905626 L6.56987296,34.8820327"
                    id="Path"
                    stroke="currentColor"
                  />
                  <path
                    d="M19.6370236,0.0362976407 L1.15571688,10.3027223 C0.465335753,10.6882033 0.0362976407,11.415608 0.0362976407,12.2061706 L0.0362976407,28.3484574"
                    id="Path"
                    stroke="currentColor"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
